// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1aoKG","noInteraction":"EventWrapper_noInteraction__1AhsE"};